import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_PROGRAM_PORTFOLIO_ANALYTICS_GET_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_PROGRAM_PORTFOLIO_ANALYTICS_GET_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_PROGRAM_PORTFOLIO_ANALYTICS_GET_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/user-programs/${id}/portfolio-analytics`,
    method: 'GET',
  })
);

export default apiCall;
